import { useTranslation } from "react-i18next";
import { Avatar, Box, Checkbox, Typography } from "@mui/material";

import { useProfileData } from "../../../../../hooks/useProfileData";
import { useGroupsListQuery } from "../../../../Groups/api/queries/useGroupsListQuery";
import { Group } from "../../../../Groups/api/types/group.types";

const GroupsTab = ({
  selectedGroupIds,
  onGroupSelect,
}: {
  selectedGroupIds: number[];
  onGroupSelect: (groupId: number) => void;
}) => {
  const { t } = useTranslation("feed", { keyPrefix: "postForm" });
  const { data: entityData, isLoading: isEntityDataLoading } = useProfileData();
  const { entityId } = entityData;

  const { data: groups } = useGroupsListQuery(entityId);

  return (
    <>
      {groups && groups?.length === 0 && (
        <Typography
          sx={{
            color: "var(--Dark---1000, #111)",
            fontFamily: "Montserrat",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "normal",
            textAlign: "center",
          }}
        >
          {t("noGroupsFound")}
        </Typography>
      )}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "25px" }}>
        {groups &&
          groups?.length > 0 &&
          groups.map((group) => (
            <GroupCard key={group.id} group={group} selectedGroupIds={selectedGroupIds} onGroupSelect={onGroupSelect} />
          ))}
      </Box>
    </>
  );
};

export default GroupsTab;

const GroupCard = ({
  group,
  selectedGroupIds,
  onGroupSelect,
}: {
  group: Group;
  selectedGroupIds: number[];
  onGroupSelect: (groupId: number) => void;
}) => {
  const { t } = useTranslation("feed", { keyPrefix: "postForm" });

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
        <Avatar
          sx={{
            width: "48px",
            height: "48px",
          }}
          src={group.imageLink}
        />
        <Box>
          <Typography
            sx={{
              color: "var(--grey-100, #171A1C)",
              fontFamily: "Montserrat",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "24px",
            }}
          >
            {group.name}
          </Typography>
          <Typography
            sx={{
              color: "var(--Dark---1000, #111)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "24px",
            }}
          >
            {t("groupMembers", { count: group.users.length })}
          </Typography>
        </Box>
      </Box>
      <Checkbox size="small" checked={selectedGroupIds.includes(group.id)} onChange={() => onGroupSelect(group.id)} />
    </Box>
  );
};
